export type ValueConverter = ((value: any) => number) | ((value: any) => string);

export function stringFloatToInt(value: string) {
    return value ? Number(value).toFixed(0) : '';
}
